import React, { useEffect } from 'react';
import { Form, Input, message, Modal } from 'antd';
import { createPromptVersion, getPromptVersionDetail, updatePromptVersion, switchPromptVersion, PromptVersionVo } from '@/api/prompt';

export interface EditVersionProp {
  templateId: number;
  data?: PromptVersionVo;
  isEdit?: boolean;
  isFirstVersion?: boolean; // 是否是第一个版本
  updateFn: () => void;
  onCancel: () => void;
}

const EditVersion = ({ templateId, data, isEdit, isFirstVersion, updateFn, onCancel }: EditVersionProp) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    if (isEdit && data?.id) {
      setLoading(true);
      getPromptVersionDetail(data.id)
        .then(res => form.setFieldsValue(res))
        .finally(() => setLoading(false));
    }
  }, [data?.id, isEdit, form]);

  const onFinish = () => {
    form.validateFields().then(values => {
      const params = { ...values, templateId, id: isEdit ? data?.id : undefined };
      const api = isEdit ? updatePromptVersion : createPromptVersion;
      setLoading(true);
      api(params as any).then((res: any) => {
        message.success('保存成功');
        // 如果是第一个版本，自动应用
        if (!isEdit && isFirstVersion && res) {
          const versionId = res.id || res;
          if (versionId) {
            switchPromptVersion({ templateId, versionId }).then(() => {
              message.success('已自动应用为当前版本');
            });
          }
        }
        onCancel();
        updateFn();
      }).finally(() => setLoading(false));
    });
  };

  return (
    <Modal
      title={isEdit ? '编辑版本' : '新增版本'}
      open={true}
      onCancel={onCancel}
      onOk={onFinish}
      maskClosable={false}
      width={700}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        {!isEdit && (
          <Form.Item name="version" label="版本号" rules={[{ required: true, message: '请输入版本号' }]}>
            <Input placeholder="如 v1.0.0" />
          </Form.Item>
        )}
        <Form.Item name="content" label="提示词内容" rules={[{ required: true, message: '请输入提示词内容' }]}>
          <Input.TextArea rows={12} placeholder="请输入提示词内容，支持 {{变量}} 占位符" />
        </Form.Item>
        <Form.Item name="changeLog" label="变更说明">
          <Input.TextArea rows={3} placeholder="本次版本的变更说明" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditVersion;